// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","352":"47ffaca5","513":"8b3c010d","625":"a9fbe009","706":"cc727622"}[chunkId] + ".chunk.js";
};